import { ButtonTextProps } from "./types"
import React from "react"
import { ButtonCore } from "./core"

const ButtonText: React.FC<ButtonTextProps> = (props) => {
  return <ButtonCore {...props} type="text"></ButtonCore>
}

export default ButtonText
